import { useEffect, useState } from 'react';
import { API_URL } from '../config';

/** Registered user count from GET /api/public/stats. Null until it loads. */
export function usePublicUserCount() {
  const [count, setCount] = useState(null);

  useEffect(() => {
    let cancelled = false;
    fetch(`${API_URL}/public/stats`)
      .then((res) => (res.ok ? res.json() : null))
      .then((data) => {
        if (!cancelled && data && Number.isInteger(data.users) && data.users >= 0) {
          setCount(data.users);
        }
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, []);

  return count;
}
